module.exports = __webpack_public_path__ + "img/_note_star.2ecca1e3.svg";